export default __webpack_public_path__ + "static/media/sideimage2.e78cdb0a.svg";